import { AudienceUsersSelectionType } from 'app/library/audience-user/enums/audience-users-selection-type.enum';
import { IRemoveAudienceUsersRequest } from 'app/library/audience-user/interfaces/remove-audience-users-request.interface';
import { UsersDownloadSelectionType } from 'app/projects/user/src/lib/enums/users-download-selection-type.enum';
import { IUsersDownloadRequest } from 'app/projects/user/src/lib/interfaces/users-download-request.interface';

export function buildAudienceMembersDownloadRequest(
    audienceId: string,
    selectedUserIds: string[],
    searchQuery: string
): IUsersDownloadRequest {
    const scope = {
        type: 'audience' as const,
        id: Number(audienceId),
    };

    if (selectedUserIds.length) {
        return {
            scope,
            selection_type: UsersDownloadSelectionType.Selected,
            user_ids: selectedUserIds.map((id) => Number(id)),
        };
    }

    const query = searchQuery?.trim();
    if (query) {
        return {
            scope,
            selection_type: UsersDownloadSelectionType.Filtered,
            filters: { query },
        };
    }

    return {
        scope,
        selection_type: UsersDownloadSelectionType.All,
    };
}

export function buildAudienceMembersRemoveRequest(selectedUserIds: string[], searchQuery: string): IRemoveAudienceUsersRequest {
    if (selectedUserIds.length) {
        return {
            selection_type: AudienceUsersSelectionType.Selected,
            user_ids: selectedUserIds.map((id) => Number(id)),
        };
    }

    const query = searchQuery?.trim();
    if (query) {
        return {
            selection_type: AudienceUsersSelectionType.Filtered,
            filters: { query },
        };
    }

    return {
        selection_type: AudienceUsersSelectionType.All,
    };
}
